import theme from 'styles/theme'

const getCmsColor = value => {
  switch (value) {
    case 'light_blue':
      return theme.colors.cms_light_blue
    case 'gray':
      return theme.colors.cms_gray
    case 'yellow':
      return theme.colors.cms_yellow
    case 'blue':
      return theme.colors.cms_blue
    case 'premium':
      return theme.colors.cms_premium
    case 'plus':
      return theme.colors.cms_plus
    case 'flex':
      return theme.colors.cms_flex
    case 'promo_economy':
      return theme.colors.cms_promo_economy
    case 'base':
      return theme.colors.cms_base
    case 'business':
      return theme.colors.cms_business
    case 'promo_business':
      return theme.colors.cms_promo_business
    case 'premium_economy_promo':
      return theme.colors.cms_premium_economy_promo
    case 'super_promo':
      return theme.colors.cms_super_promo
    default:
      return value
  }
}

const getCmsFont = value => value && FONT[`${(value || '').toUpperCase()}`]

const FONT = {
  REGULAR: theme.fonts.regular,
  SEMIBOLD: theme.fonts.semiBold,
  BOLD: theme.fonts.bold,
  BLACK: theme.fonts.black,
  ITALIC: theme.fonts.italic,
  REGULAR_REGULAR: theme.fonts.regular_regular,
  REGULAR_MEDIUM: theme.fonts.regular_medium,
  REGULAR_SEMIBOLD: theme.fonts.regular_semibold,
  REGULAR_BLACK: theme.fonts.regular_black,
  REGULAR_EXTRABOLD: theme.fonts.regular_extrabold,
  ARIAL_REGULAR: theme.fonts.arial_regular,
  ARIAL_MEDIUM: theme.fonts.arial_medium,
  ARIAL_SEMIBOLD: theme.fonts.arial_semibold,
  ARIAL_BLACK: theme.fonts.arial_black,
  ARIAL_EXTRABOLD: theme.fonts.arial_extrabold,
  TAHOMA_REGULAR: theme.fonts.tahoma_regular,
  TAHOMA_MEDIUM: theme.fonts.tahoma_medium,
  TAHOMA_SEMIBOLD: theme.fonts.tahoma_semibold,
  TAHOMA_BLACK: theme.fonts.tahoma_black,
  TAHOMA_EXTRABOLD: theme.fonts.tahoma_extrabold
}

const TAGS = {
  P: 'p',
  TABLE: 'table',
  TR: 'tr',
  TH: 'th',
  TD: 'td'
}

const CMS_PROPERTIES = {
  COLOR: 'color',
  SIZE: 'size',
  FONT: 'font',
  FONT_STYLE: 'font_style',
  WIDTH: 'width',
  BGCOLOR: 'bgcolor',
  BORDERCOLOR: 'bordercolor'
}

const CSS_PROPERTIES = {
  [CMS_PROPERTIES.COLOR]: 'color',
  [CMS_PROPERTIES.SIZE]: 'font-size',
  [CMS_PROPERTIES.FONT]: 'font-family',
  [CMS_PROPERTIES.FONT_STYLE]: 'font-style',
  [CMS_PROPERTIES.WIDTH]: 'width',
  [CMS_PROPERTIES.BGCOLOR]: 'background-color',
  [CMS_PROPERTIES.BORDERCOLOR]: 'border'
}

const DEFINE_CMS_CLASS = {
  [TAGS.P]: {
    [CMS_PROPERTIES.COLOR]: CSS_PROPERTIES[[CSS_PROPERTIES.COLOR]],
    [CMS_PROPERTIES.SIZE]: CSS_PROPERTIES[[CSS_PROPERTIES.SIZE]],
    [CMS_PROPERTIES.FONT]: CSS_PROPERTIES[[CSS_PROPERTIES.FONT]],
    [CMS_PROPERTIES.FONT_STYLE]: CSS_PROPERTIES[[CSS_PROPERTIES.FONT_STYLE]]
  },
  [TAGS.TABLE]: {
    [CMS_PROPERTIES.WIDTH]: CSS_PROPERTIES[[CSS_PROPERTIES.WIDTH]],
    [CMS_PROPERTIES.BGCOLOR]: CSS_PROPERTIES[[CSS_PROPERTIES.BGCOLOR]],
    [CMS_PROPERTIES.FONT]: CSS_PROPERTIES[[CSS_PROPERTIES.FONT]],
    [CMS_PROPERTIES.BORDERCOLOR]: CSS_PROPERTIES[[CSS_PROPERTIES.BORDERCOLOR]]
  },
  [TAGS.TR]: {
    [CMS_PROPERTIES.BORDERCOLOR]: CSS_PROPERTIES[[CSS_PROPERTIES.BORDERCOLOR]],
    [CMS_PROPERTIES.BGCOLOR]: CSS_PROPERTIES[[CSS_PROPERTIES.BGCOLOR]]
  },
  [TAGS.TH]: {
    [CMS_PROPERTIES.BGCOLOR]: CSS_PROPERTIES[[CSS_PROPERTIES.BGCOLOR]],
    [CMS_PROPERTIES.BORDERCOLOR]: CSS_PROPERTIES[[CSS_PROPERTIES.BORDERCOLOR]],
    [CMS_PROPERTIES.SIZE]: CSS_PROPERTIES[[CSS_PROPERTIES.SIZE]],
    [CMS_PROPERTIES.FONT]: CSS_PROPERTIES[[CSS_PROPERTIES.FONT]]
  },
  [TAGS.TD]: {
    [CMS_PROPERTIES.BGCOLOR]: CSS_PROPERTIES[[CSS_PROPERTIES.BGCOLOR]],
    [CMS_PROPERTIES.BORDERCOLOR]: CSS_PROPERTIES[[CSS_PROPERTIES.BORDERCOLOR]],
    [CMS_PROPERTIES.SIZE]: CSS_PROPERTIES[[CSS_PROPERTIES.SIZE]],
    [CMS_PROPERTIES.FONT]: CSS_PROPERTIES[[CSS_PROPERTIES.FONT]]
  }
}

const buildRegexCmsClass = () => {
  let tag = ''
  let property = ''

  for (const prop in DEFINE_CMS_CLASS) {
    if (!DEFINE_CMS_CLASS[prop]) {
      tag += `${prop}|`
    } else {
      Object.keys(DEFINE_CMS_CLASS[prop]).forEach(key => {
        !tag.includes(prop) && (tag += `${prop}|`)
        !property.includes(key) && (property += `${key}|`)
      })
    }
  }

  const group_tag = `(?<tag>${(tag || '').slice(0, -1)})`
  const group_property = `(?<property>${(property || '').slice(0, -1)})`
  const group_value = `(?<value>[a-z0-9_%]*)`
  const cssClass = `${group_tag}-(?:${group_property}-)?${group_value}`

  return new RegExp(cssClass, 'g')
}

const addClass = ({ tag, className, property, value, addPropertiesList, addClassList = null }) =>
  !(tag && className && property)
    ? ''
    : (!value
      ? ''
      : `
        ${tag}.${className.replace('%', '\\%')} {
                ${CSS_PROPERTIES[property]}: ${value} !important;
                ${(addPropertiesList || []).join('')}
              }`) + (addClassList || []).join('')

const buildCss = ({ className, tag, property, value }) => {
  const BORDER_WIDTH = '2px'
  switch (`${tag}-${property}`) {
    case `${TAGS.TABLE}-${CMS_PROPERTIES.WIDTH}`:
      return addClass({
        tag,
        className,
        property,
        value,
        addPropertiesList: ['display: table !important;']
      })

    case `${TAGS.TABLE}-${CMS_PROPERTIES.BORDERCOLOR}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} tr td {
            border: ${BORDER_WIDTH} solid ${getCmsColor(value)} !important;
            }`
        ]
      })
    case `${TAGS.TR}-${CMS_PROPERTIES.BORDERCOLOR}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `.${className} > * {
              border-top: ${BORDER_WIDTH} solid ${getCmsColor(value)} !important;
              border-bottom: ${BORDER_WIDTH} solid ${getCmsColor(value)} !important;
             }`,
          `.${className} > *:first-child {
              border-left: ${BORDER_WIDTH} solid ${getCmsColor(value)} !important;
             }`,
          `.${className} > *:last-child {
              border-right: ${BORDER_WIDTH} solid ${getCmsColor(value)} !important;
             }`
        ]
      })
    case `${TAGS.TH}-${CMS_PROPERTIES.BORDERCOLOR}`:
    case `${TAGS.TD}-${CMS_PROPERTIES.BORDERCOLOR}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} {
            border: ${BORDER_WIDTH} solid ${getCmsColor(value)} !important; }`
        ]
      })

    case `${TAGS.TABLE}-${CMS_PROPERTIES.BGCOLOR}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} tr td {
            background: ${getCmsColor(value)} !important; }`
        ]
      })
    case `${TAGS.TR}-${CMS_PROPERTIES.BGCOLOR}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} > * {
            background: ${getCmsColor(value)} !important; }`
        ]
      })
    case `${TAGS.TH}-${CMS_PROPERTIES.BGCOLOR}`:
    case `${TAGS.TD}-${CMS_PROPERTIES.BGCOLOR}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} {
            background: ${getCmsColor(value)} !important; }`
        ]
      })

    case `${TAGS.TABLE}-${CMS_PROPERTIES.COLOR}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} * {
            color: ${getCmsColor(value)} !important; }`
        ]
      })
    case `${TAGS.TR}-${CMS_PROPERTIES.COLOR}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} > * {
            color: ${getCmsColor(value)} !important; }`
        ]
      })
    case `${TAGS.TH}-${CMS_PROPERTIES.COLOR}`:
    case `${TAGS.TD}-${CMS_PROPERTIES.COLOR}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} {
            color: ${getCmsColor(value)} !important; }`,
          `${tag}.${className} p {
            color: ${getCmsColor(value)} !important; }`
        ]
      })

    case `${TAGS.TABLE}-${CMS_PROPERTIES.FONT}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} * {
            font-family: ${getCmsFont(value)} !important; }`
        ]
      })
    case `${TAGS.TR}-${CMS_PROPERTIES.FONT}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} > * {
            font-family: ${getCmsFont(value)} !important; }`
        ]
      })
    case `${TAGS.TH}-${CMS_PROPERTIES.FONT}`:
    case `${TAGS.TD}-${CMS_PROPERTIES.FONT}`:
    case `${TAGS.P}-${CMS_PROPERTIES.FONT}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} {
            font-family: ${getCmsFont(value)} !important; }`,
          `${tag}.${className} p {
            font-family: ${getCmsFont(value)} !important; }`
        ]
      })

    case `${TAGS.P}-${CMS_PROPERTIES.FONT_STYLE}`:
      return addClass({
        tag,
        className,
        property,
        addClassList: [
          `${tag}.${className} {
            font-style: ${value} !important; }`
        ]
      })

    default:
      return addClass({
        tag,
        className,
        property,
        value: getCmsColor(value)
      })
  }
}

export const parseCmsClass = async (text, document = null) => {
  let regex = buildRegexCmsClass()

  if (!regex) return

  let cssString = ''

  let match
  while ((match = regex.exec(text)) != null) {
    cssString.indexOf(match[0] + ' ') < 0 &&
      (cssString += buildCss({ className: match[0], ...(match.groups || {}) }))
  }

  if (cssString) {
    let css = document.createElement('style')
    css.type = 'text/css'
    css.innerHTML = cssString
    document.head.appendChild(css)
  }
  return cssString
}
